import { render, staticRenderFns } from "./DispatchDrawer.vue?vue&type=template&id=b7345f6e"
import script from "./DispatchDrawer.vue?vue&type=script&lang=js"
export * from "./DispatchDrawer.vue?vue&type=script&lang=js"
import style0 from "./DispatchDrawer.vue?vue&type=style&index=0&id=b7345f6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports